import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const ledgerKeys = {
  accounts: ["ledger", "accounts"] as const,
  entries: (code: string) => ["ledger", "entries", code] as const,
};

export function useLedgerAccounts() {
  return useQuery({
    queryKey: ledgerKeys.accounts,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/api/v1/ledger/accounts", {});
      if (error || !data) throw new Error("Failed to load accounts");
      return data;
    },
  });
}

export function useLedgerEntries(accountCode?: string) {
  return useQuery({
    queryKey: ledgerKeys.entries(accountCode ?? "all"),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/api/v1/ledger/entries", {
        params: { query: accountCode ? { account_code: accountCode } : {} },
      });
      if (error || !data) throw new Error("Failed to load ledger entries");
      return data;
    },
  });
}
